// Presentation only. All rows, totals and rates come from the dashboard summary API.
const businessUnitColumn = (title = 'BU') => ({
  title, dataIndex: 'business_unit', key: 'business_unit', width: 150, fixed: 'left', align: 'center'
});
const amountColumn = (title, dataIndex, decimals = 0, totalDecimals = decimals) => ({
  title, dataIndex, key: dataIndex, width: 190, decimals, totalDecimals
});
const percentageColumn = (title, dataIndex, percentageDecimals = 0) => ({
  title, dataIndex, key: dataIndex, width: 110, align: 'center', percentageDecimals
});

export const dutySavingSections = [
  {
    key: 'total-refund',
    title: 'Total Refund benefit',
    width: 540,
    columns: [businessUnitColumn(), amountColumn('Sum of Sum of Total Refund Benefit FCC', 'refund')]
  },
  {
    key: 'effective-duty',
    title: 'Effective Duty Rate net of incentive',
    width: 1040,
    columns: [
      businessUnitColumn('Business Unit'),
      amountColumn("Sum of BE Ass'able Amt. (FCC)", 'assessable'),
      amountColumn('Sum of Total Duty Paid (BCD+SWS) (FCC)', 'duty_paid'),
      amountColumn('Sum of Sum of Total Refund benefit in FCC', 'refund'),
      amountColumn('Sum of Net Duty (FCC)', 'net_duty'),
      percentageColumn('Duty Rate', 'duty_rate', 2)
    ]
  },
  {
    key: 'export-incentive',
    title: 'Export Incentive DBK Air + SBR and Rodtep (FCC)',
    width: 760,
    columns: [
      businessUnitColumn(),
      amountColumn('Sum of DBK Eligible Amt FCC', 'dbk'),
      amountColumn('Sum of RoDTEP Eligible Amt FCC', 'rodtep'),
      amountColumn('Sum of SBR Eligible Amt FCC', 'sbr')
    ]
  },
  {
    key: 'trade-benefits',
    title: 'Total Trade Benefits',
    width: 1480,
    columns: [
      { title: 'Sum of BCD Duty Forgone (FCC)', key: 'duty_forgone', children: [businessUnitColumn('Business Unit')] },
      {
        title: 'Category', key: 'category', children: [
          amountColumn('Customs Notification', 'customs'),
          amountColumn('FTA', 'fta'),
          amountColumn('SEZ Benefit', 'sez'),
          amountColumn('Sum of RODTEP', 'rodtep', 2, 0),
          amountColumn('Sum of DBK', 'dbk', 2, 0),
          amountColumn('Sum of DBK SBR', 'sbr', 2, 0),
          amountColumn('Sum of Benefits Grand total', 'benefits', 2, 0)
        ]
      }
    ]
  },
  {
    key: 'trade-benefits-millions',
    title: 'Total Trade Benefits (Amount in-M$)',
    width: 540,
    columns: [
      { title: 'Particular', dataIndex: 'particular', key: 'particular', width: 280 },
      amountColumn('Amount in-M$', 'amount', 2)
    ]
  },
  {
    key: 'export-reports',
    title: 'Export Reports',
    width: 2190,
    columns: [
      businessUnitColumn(),
      amountColumn('Sum of RoDTEP Eligible Amt FCC', 'rodtep_eligible'),
      amountColumn('Sum of RoDTEP Received Amt FCC', 'rodtep_received'),
      amountColumn('Sum of RoDTEP Pending Amt FCC', 'rodtep_pending'),
      amountColumn('Sum of DBK Eligible Amt FCC', 'dbk_eligible'),
      amountColumn('Sum of DBK Received Amt FCC', 'dbk_received'),
      amountColumn('Sum of DBK Pending Amt FCC', 'dbk_pending'),
      amountColumn('Sum of SBR Eligible Amt FCC', 'sbr_eligible'),
      amountColumn('Sum of SBR Received Amt FCC', 'sbr_received'),
      amountColumn('Sum of SBR Pending Amt FCC', 'sbr_pending'),
      percentageColumn('Rodtep in %', 'rodtep_percentage'),
      percentageColumn('DBK in %', 'dbk_percentage'),
      percentageColumn('SBR in %', 'sbr_percentage')
    ]
  }
];
